var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prijava-forma',{attrs:{"disabled":true,"id":_vm.id,"modal":false,"action":'show'}})}
var staticRenderFns = []

export { render, staticRenderFns }